import { connect } from 'react-redux';
import Avatar from './Avatar';

const mapStateToProps = (state, ownProps) => ({
  user: state.users[ownProps.userId],
  currentUserId: state.identity && state.identity.id
});

export default connect(mapStateToProps)(Avatar);
